export default () => {
  document.addEventListener('language', (e) => {
    const lang = e.detail;

    document.querySelectorAll('.js-translatable').forEach((el) => {
      const dataTraslatableStr = el.getAttribute('data-translatable');
      let dataTraslatable;
      try {
        dataTraslatable = JSON.parse(dataTraslatableStr);
      } catch (e) {
        return;
      }

      el.innerHTML = dataTraslatable[lang];
    });
  });
};



// WEBPACK FOOTER //
// ./app/Assets/js/utils/translator.js